import { BASE_ESCALATION_FILTERS } from "./escalatedPage.constants"

const MAX_OPPID_QUERY_LENGTH = 200;

export const normalizeEscalationOppIdQuery = (raw: string | null): string | null => {
    if (raw == null) return null;
    const trimmed = raw.trim();
    if (!trimmed) return null;
    if (trimmed.length > MAX_OPPID_QUERY_LENGTH) return null;
    return trimmed;
};

export const getDefaultEscalationFilters = (devId: string) => {
    return {
        ...BASE_ESCALATION_FILTERS,
        createdBy: [devId]
    }
}